import React from 'react';
import * as ReactUI from 'react-bootstrap';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { darkModeState, enterState } from '../../atoms';
import * as Icon from '../../data/photoUrls';

export const HomeWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const darkMode = useRecoilValue(darkModeState);
  const setEnterStateValue = useSetRecoilState(enterState);
  const toggle = () => setEnterStateValue(false);
  const themeState = !darkMode ? 'row-container' : 'row-container-dark';

  const ExpandButton = () => (
    <div id="home" className="littleNav sticky-top">
      <ReactUI.Button
        onClick={toggle}
        className="expand"
        style={{ marginLeft: 'auto' }}
      >
        {!darkMode ? (
          <div expand-title={'Exit'}>
            <ReactUI.Image
              src={Icon.expand}
              className="expandIcon"
              alt=""
              width="23px"
            />
          </div>
        ) : (
          <div expand-title={'Exit'}>
            <ReactUI.Image
              src={Icon.expandDark}
              className="expandIcon"
              alt=""
              width="23px"
            />
          </div>
        )}
      </ReactUI.Button>
    </div>
  );

  return (
    <ReactUI.Container id={themeState}>
      <div id="blur" className="blurWrapper"></div>
      <ExpandButton />
      {children}
    </ReactUI.Container>
  );
};
